import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQuery } from '../../api/hooks';
import { isStaff } from '../../lib/roles';
import { Audit } from './audit';

// What is recorded against no organization: organizations made and removed, devices registered, assigned and deleted.
export const Route = createFileRoute('/_app/trail')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.fetchQuery(meQuery);
    if (!me || !isStaff(me)) throw redirect({ to: '/overview', search: {} });
  },
  component: Audit,
});
